import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { ICardPreviewHOCProps } from './types';
import { CardPreview } from '../../components/CardPreview/CardPreview';
import { ICardPreviewField } from '../../components/CardPreview/types';
import { getBoardUsers } from '../../../../../../../store/model/selectors/getBoardUsers';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { getPreviewSettingsCreateSelector } from '../PreviewHOC/selectors/getPreviewSettings';

const mapStateToProps = () => {
    const getPreviewSettings = getPreviewSettingsCreateSelector();

    const _mapStateToProps = (
        state: IApplicationState,
        { boardId }: ICardPreviewHOCProps
    ): ICardPreviewField => {
        const { permissionId } = getAuthUser(state);
        return {
            assignees: getBoardUsers(state, boardId).slice(0, 3).map(user => {
                return {
                    sharedUser: user,
                    roleIds: [],
                };
            }),
            activeSettings: getPreviewSettings(state, boardId).filter(item => item.value).map(item => item.key),
            authUserPermissionId: permissionId,
            boardUsers: getBoardUsers(state, boardId),
        };
    };

    return _mapStateToProps;
};

export const CardPreviewHOC = connect(
    mapStateToProps,
    null
)(CardPreview);

CardPreviewHOC.displayName = 'CardPreviewHOC';
